import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { batch } from 'react-redux';
import { merge } from '@chegg/commerce-utils';
import { createStore } from '../redux/store';
import { executeCommands as _executeCommands } from '../redux/CommandState/CommandState.actions';
import { saveConfigs } from '../redux/ConfigState/ConfigState.slice';
import { defaultConfigs } from '../business/configManager/types';
var store;
var shouldRemergeConfigs = false;
export var StoreBuilder = function StoreBuilder() {
  return {
    getStore: function getStore(_ref) {
      var config = _ref.config,
        additionalState = _ref.additionalState,
        testMode = _ref.testMode;
      if (!testMode && store) {
        if (shouldRemergeConfigs) {
          store.dispatch(saveConfigs(merge({}, defaultConfigs, _objectSpread({}, config))));
          shouldRemergeConfigs = false;
        }
        return store;
      }
      var initialState = _objectSpread({
        config: merge({}, defaultConfigs, _objectSpread({}, config))
      }, additionalState);
      store = createStore(initialState);
      return store;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    executeCommands: function executeCommands(commands) {
      var _store;
      (_store = store) === null || _store === void 0 || _store.dispatch(_executeCommands(commands));
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    resetStore: function resetStore(initialConfig) {
      batch(function () {
        store.dispatch({
          type: 'RESET_STORE'
        });
        store.dispatch(saveConfigs(merge({}, defaultConfigs, _objectSpread({}, initialConfig))));
      });
      shouldRemergeConfigs = true;
    },
    debug: function debug() {
      return store;
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/utils/ReduxStoreUtil.js
// module id = 1484
// module chunks = 11